export default "__VITE_ASSET__L9$JtIHTb8LwAJcRaXbAYQ__"